import { GetServerSideProps } from 'next';
import SEOHead from '../../components/SEOHead';

export default function SvetainiuProgramavimasPage() {
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'ProfessionalService',
    name: 'Svetainių programavimas',
    description: 'Profesionalus svetainių programavimas Lietuvoje. Individualios svetainių programos, sukurtos naudojant šiuolaikines technologijas verslams, siekiantiems pažangių skaitmeninių sprendimų.',
    provider: {
      '@type': 'Organization',
      name: 'LB Visible',
      url: 'https://www.lbvisible.com',
      knowsAbout: [
        'Svetainių programavimas',
        'Individualios svetainių programos',
        'Pilno steko kūrimas',
        'API kūrimas',
        'Duomenų bazės dizainas',
      ],
    },
    areaServed: {
      '@type': 'Country',
      name: 'Lithuania',
    },
  };

  return (
    <>
      <SEOHead
        title='Svetainių programavimas | LBVisible'
        description='Profesionalus svetainių programavimas Lietuvoje. Individualios svetainių programos, sukurtos naudojant šiuolaikines technologijas verslams, siekiantiems pažangių skaitmeninių sprendimų.'
        keywords='svetainių programavimas, individualios svetainių programos, pilno steko kūrimas, svetainių programų kūrimas Lietuvoje, API kūrimas'
        canonicalUrl='/lt/svetainiu-programavimas'
        lang='lt'
        structuredData={structuredData}
      />

      <main className='min-h-screen max-w-4xl mx-auto px-4 sm:px-6 py-12'>
        <article className='prose prose-lg dark:prose-invert max-w-none'>
          <style jsx global>{`
            article h1 {
              font-size: 2.25rem;
              font-weight: 700;
              margin-top: 2rem;
              margin-bottom: 1.5rem;
              line-height: 1.2;
            }
            article h2 {
              font-size: 1.875rem;
              font-weight: 700;
              margin-top: 2rem;
              margin-bottom: 1rem;
              line-height: 1.3;
            }
            article h3 {
              font-size: 1.5rem;
              font-weight: 600;
              margin-top: 1.5rem;
              margin-bottom: 0.75rem;
              line-height: 1.4;
            }
            article p {
              margin-bottom: 1.5rem;
              line-height: 1.75;
            }
          `}</style>
          <h1 className='text-gray-900 dark:text-white'>Svetainių programavimas ir kūrimas</h1>
          
          <h2 className='text-gray-900 dark:text-white'>Kodėl profesionalus svetainių programavimas svarbus</h2>
          <p className='text-gray-700 dark:text-gray-400'>
            Svetainių programavimas yra dinamiškų, interaktyvių programų, kurios veikia naršyklėse, kūrimo procesas. 
            Skirtingai nuo statinių svetainių, svetainių programos suteikia funkcionalumą, interaktyvumą ir duomenų 
            valdymo galimybes, kurios leidžia verslams automatizuoti procesus, valdyti informaciją ir teikti paslaugas 
            internete. Profesionalus svetainių programavimas užtikrina, kad jūsų programa būtų saugi, mastuojama ir 
            efektyviai veiktų įvairiomis sąlygomis.
          </p>

          <h2 className='text-gray-900 dark:text-white'>Mūsų svetainių programavimo procesas</h2>
          <p className='text-gray-700 dark:text-gray-400'>
            Mūsų svetainių programavimo procesas prasideda nuo išsamaus jūsų verslo reikalavimų ir techninių poreikių 
            analizės. Projektuojame programos architektūrą, parenkame tinkamas technologijas ir kurime individualius 
            sprendimus, pritaikytus jūsų specifiniams poreikiams. Naudojame šiuolaikines sistemas ir įrankius, kad 
            užtikrintume, jog jūsų svetainių programa būtų priežiūros, mastuojama ir atspari ateities iššūkiams. 
            Visą kūrimo procesą orientuojamės į saugumą, našumą ir vartotojo patirtį.
          </p>

          <h3 className='text-gray-900 dark:text-white'>Pilno steko kūrimas</h3>
          <p className='text-gray-700 dark:text-gray-400'>
            Teikiame pilno steko svetainių programavimo paslaugas, tvarkydami tiek priekinę, tiek užpakalinę dalis. 
            Mūsų patirtis apima React, Next.js, Node.js ir įvairias duomenų bazės technologijas. Kuriamo sklandžias 
            integracijas tarp skirtingų komponentų, užtikrindami, kad jūsų svetainių programa veiktų sklandžiai ir 
            efektyviai.
          </p>

          <h3 className='text-gray-900 dark:text-white'>API kūrimas ir integracija</h3>
          <p className='text-gray-700 dark:text-gray-400'>
            Kurime individualius API ir integruojame trečiųjų šalių paslaugas, kad išplėstume jūsų svetainių programos 
            funkcionalumą. Mūsų API kūrimo paslaugos užtikrina saugų, efektyvų duomenų mainus ir leidžia jūsų programai 
            efektyviai komunikuoti su kitomis sistemomis ir paslaugomis.
          </p>

          <h2 className='text-gray-900 dark:text-white'>Kodėl rinktis LBVisible svetainių programavimui</h2>
          <p className='text-gray-700 dark:text-gray-400'>
            LBVisible mes suprantame, kad svetainių programavimas reikalauja techninės patirties, dėmesio detalėms ir 
            gilio verslo poreikių supratimo. Sujungiame šiuos elementus, kad pristatytume svetainių programas, kurios 
            ne tik atitinka jūsų reikalavimus, bet ir viršija lūkesčius. Mūsų kūrimo požiūris orientuotas į sprendimų, 
            kurie yra priežiūros, mastuojami ir atitinka jūsų verslo tikslus, kūrimą.
          </p>

          <p className='text-gray-700 dark:text-gray-400'>
            Mūsų svetainių programavimo paslaugos apima individualų kūrimą, duomenų bazės dizainą, API kūrimą, 
            trečiųjų šalių integracijas ir tęstinę priežiūrą. Visą projektą dirbame glaudžiai su jumis, užtikrindami 
            skaidrumą, reguliarų atnaujinimą ir laiku pristatymą.
          </p>

          <p className='text-gray-700 dark:text-gray-400'>
            Nesvarbu, ar jums reikia klientų portalo, administravimo skydelio, el. prekybos platformos ar bet kokios 
            kitos individualios svetainių programos, turime patirtį, kad įgyvendintume jūsų viziją. Susisiekite su 
            mumis šiandien, kad aptartumėte savo svetainių programavimo poreikius ir sužinotumėte, kaip galime padėti 
            jūsų verslui sėkmės internete.
          </p>
        </article>
      </main>
    </>
  );
}

export const getServerSideProps: GetServerSideProps = async () => {
  return {
    props: {},
  };
};

